import { SerializedStyles, Theme, css } from "@emotion/react"

export const titleContainer = css`
	display: flex;
	position: relative;
`

export const outerContainerStyle = (theme: Theme): SerializedStyles => css`
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	> div:first-of-type {
		flex-grow: 1;
		margin-right: 1.5rem;

		${theme.breakpoints.down("sm")} {
			margin-right: 0;
		}
	}

	> div:first-of-type {
		margin-bottom: 0;
	}

	${theme.breakpoints.down("sm")} {
		display: block;
	}

	input {
		width: 100%;
	}

	div.step-content {
		margin-top: 1.5rem;
	}
`
export const stepContainerStyle = (theme: Theme, hasAddress?: boolean): SerializedStyles => css`
	color: ${hasAddress ? "black" : theme.palette.text.secondary};
	margin-top: 2rem;
	padding: 1.5rem;
	margin-bottom: 1rem;
	border-bottom: 1px solid #eee;
`

export const styleStepNumberText = (theme: Theme, active?: boolean): SerializedStyles => css`
	color: ${active ? "#0b75e1" : "#9CA3AF"};
	font-size: 1.25rem;
	font-weight: 700;
`

export const styleStepNumber = (theme: Theme, active?: boolean): SerializedStyles => css`
	width: 2rem;
	height: 2rem;
	border-radius: 1em;
	text-align: center;
	margin-right: 1em;
	color: ${active ? "#0b75e1" : "#9CA3AF"};
	border: 1px solid ${active ? "#0b75e1" : "#9CA3AF"};
	text-align: center;
	font-size: 1rem;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: center;

	div {
		margin-top: -2px;
	}
`

export const styleCollapseIcon = css`
	all: unset;
	right: 0.5em;
	position: absolute;
	cursor: pointer;
	height: 1em;
	width: 1em;
`
